import localFont from "next/font/local";

export const switzer = localFont({
  src: [
    {
      path: "./Switzer-Thin.otf",
      weight: "100",
      style: "normal",
    },
    {
      path: "./Switzer-ThinItalic.otf",
      weight: "100",
      style: "italic",
    },
    {
      path: "./Switzer-Extralight.otf",
      weight: "200",
      style: "normal",
    },
    {
      path: "./Switzer-ExtralightItalic.otf",
      weight: "200",
      style: "italic",
    },
    {
      path: "./Switzer-Light.otf",
      weight: "300",
      style: "normal",
    },
    {
      path: "./Switzer-LightItalic.otf",
      weight: "300",
      style: "italic",
    },
    {
      path: "./Switzer-Regular.otf",
      weight: "400",
      style: "normal",
    },
    {
      path: "./Switzer-Italic.otf",
      weight: "400",
      style: "italic",
    },
    {
      path: "./Switzer-Medium.otf",
      weight: "500",
      style: "normal",
    },
    {
      path: "./Switzer-MediumItalic.otf",
      weight: "500",
      style: "italic",
    },
    {
      path: "./Switzer-Semibold.otf",
      weight: "600",
      style: "normal",
    },
    {
      path: "./Switzer-SemiboldItalic.otf",
      weight: "600",
      style: "italic",
    },
    {
      path: "./Switzer-Bold.otf",
      weight: "700",
      style: "normal",
    },
    {
      path: "./Switzer-BoldItalic.otf",
      weight: "700",
      style: "italic",
    },
    {
      path: "./Switzer-Extrabold.otf",
      weight: "800",
      style: "normal",
    },
    {
      path: "./Switzer-ExtraboldItalic.otf",
      weight: "800",
      style: "italic",
    },
    {
      path: "./Switzer-Black.otf",
      weight: "900",
      style: "normal",
    },
    {
      path: "./Switzer-BlackItalic.otf",
      weight: "900",
      style: "italic",
    },
  ],
});

export default switzer;
